<template>
  <div id="app">
    <!-- animation is almost useless cuz fast loadi -->
    <div id="loading-animaiton" class="loadingAnimaiton">
      <br><br><br>
      <img src="logo.svg" alt="logo">
      <br><br>
      <div>
        <div class="spinner">
          <span class="spinner-1"></span>
          <span class="spinner-2"></span>
        </div>
        <p class="loadingText"> الرجاْ الإنتظار قليلا </p>
      </div>
    </div>

    <!-- online/offline status -->
    <div class="online">
      <p>لا يوجد اتصال بالانترنت</p>
    </div>
    
    <transition type="transition" name="fadee" mode="out-in" appear>
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
    <br>
    <footer-cmp v-if='
    $route.path == "/settings" ||
    $route.path == "/calender" ||
    $route.path == "/quran" ||
    $route.path == "/adkar" ||
    $route.path == "/" ||
    $route.path == "/settings"
    '></footer-cmp>

    <div class="myBackground">
      <div></div>
      <div></div>
      <div></div>
    </div>

  </div>
</template>

<script>
import footerSide from "./components/footer-side.vue"

export default {
  data() {
    return {
      internetConnection: navigator.onLine
    }
  },
  components: {
    footerCmp: footerSide,
  },
  methods: {
    net() {
      if(this.internetConnection != true) {
        document.querySelector(".online").style.top = "0px";
        console.log("no internet")
      } else {
        document.querySelector(".online").style.top = "-300px";
        console.log("yes internet")
      }
    }
  },
  watch: {
    'this.$store.state.hsys'() {
      //console.log("\ntimes update system\n");
      this.myAxios();
      //console.log("\nclock update system\n");
      this.timeInAxios();
    },

    internetConnection() {
      this.net();
    }
  },
  /**
   * setop is an instantce can use it for the
   * keep-alive, in return we adding the bolean of the keepalive
   * true or false, then add the attribute that we add in the tag before
   * the "include" attribute is an array od names of the cmp's that 
   * we want them keepAlive
   */
  setup() {
    return {
      keepAlive: true,
      include: ["settingsActive", "homeActive"],
    };
  },
  // methods: {
  //   loadingAnimation() {
  //     console.log("loading animation function here");
  //     document.getElementById("loading-animaiton").remove();
  //     }
  // },
  mounted() {
    this.net();
    console.log("mountede app");
    document.querySelector('.loadingAnimaiton').style.display = 'none';
    // this.loadingAnimation();
  }
}
</script>

<style scoped>
.myBackground {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.3;
}

.myBackground div {
  position: fixed;
  width: 300px;
  height: 300px;
  border-radius: 100%;
  transform: scale(1);
}

.myBackground div:nth-child(1) {
  top: -100px;
  right: -200px;
  background: var(--mainColor);
  width: 400px;
  height: 400px;
  opacity: 0.7;
  animation: myBackground 17s infinite linear;
}

.myBackground div:nth-child(2) {
  bottom: 50px;
  left: -250px;
  background: var(--mainColor);
  width: 400px;
  height: 400px;
  opacity: 0.5;
  animation: myBackground 20s infinite linear;
}

.myBackground div:nth-child(3) {
  bottom: -200px;
  right: -100px;
  background: var(--mainColor);
  opacity: 0.35;
  animation: myBackground 18s infinite linear;
}

@keyframes myBackground {
  50% {
    transform: scale(1.2);
  }
}

.fadee-enter-active,
.fadee-leave-active {
  transition: opacity .3s;
}

.fadee-enter,
.fadee-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}



/* 
.fadee-enter {
  opacity: 1;
  transition: 0.3s ease all !important;
}
.fadee-enter-active {
  opacity: 0;
  transition: 0.3s ease all !important;
}
.fadee-leave {
  opacity: 1;
  transition: 0.3s ease all !important;
}
.fadee-leave-active {
  opacity: 0;
  transition: 0.3s ease all !important;
} */

#loading-animaiton {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00DE9A;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 11111;
  transition: none;
}

#loading-animaiton img {
  width: 100px;
  display: block !important;
}

#loading-animaiton div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100px;
  margin-bottom: -100px;
}

#loading-animaiton div .spinner {
  width: 40px;
}

#loading-animaiton div .spinner .spinner-1 {
  position: absolute;
  border-radius: 50px;
  border: 4px solid #fff;
  border-right-color: rgba(255, 255, 255, 0);
  border-top-color: rgba(255, 255, 255, 0);
  width: 40px;
  height: 40px;
  animation: loading-spinner 1s infinite linear;
}

#loading-animaiton div .spinner .spinner-2 {
  position: absolute;
  border-radius: 50px;
  border: 4px solid rgba(255, 255, 255, 0.4666666667);
  border-left-color: rgba(255, 255, 255, 0);
  border-bottom-color: rgba(255, 255, 255, 0);
  width: 40px;
  height: 40px;
  animation: loading-spinner 2s infinite linear reverse;
}

#loading-animaiton div .loadingText {
  color: #fff;
  text-align: center;
  transition: none;
  display: none;
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
